
import { defineComponent } from "vue-demi";

export default defineComponent({
  name: "VEmployerVisaCasesTemplate",

  components: {
    EmployeeCard: () => import("./components/EmployeeCard.vue"),
    Table: () => import("./components/Table.vue"),
  },

  setup() {
    return {};
  },
});
